import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { FormControl } from '@mui/material';

// import Loader from '../../pages/Loader/Loader';
import axios from 'axios';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  outline: 'none',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  marginTop: 4,
};

const theme = createTheme({
  palette: {
    neutral: {
      main: '#F0411A',
      contrastText: '#fff',
    },
    neutralsize: {
      width: '10px',
    },
  },
});

const VideoListModaledit = ({ render, setRender, item }) => {
  const [open, setOpen] = React.useState(false);
  // const [loading, setLoading] = React.useState(false);

  console.log('edit : ', item);

  const [editName, setEditName] = React.useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // const [age, setAge] = React.useState('');

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };

  const editHandler = async () => {
    try {
      // setLoading(true);
      const response = await fetch(
        `api/v1/a34jl49u-q4r67p89/courses/${item.course._id}/chapter/${item.chapter._id}/video/${item._id}`,
        {
          method: 'PATCH',
          body: JSON.stringify({ name: editName }),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200 || response.statusText === 'OK') {
        toast.success('success');
        setRender(!render);
        handleClose();
        return;
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Button sx={{ minWidth: '10px !important' }} onClick={handleOpen}>
          <EditIcon sx={{ color: '#686868' }} />
        </Button>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            Create Two Digit Lucky Number
          </Typography> */}
          <Typography id='modal-modal-description' sx={{ mt: 2 }}>
            <TextField
              sx={{ width: '100%' }}
              id='outlined-search'
              label='Name'
              type='text'
              onChange={(e) => setEditName(e.target.value)}
            />
            <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='Link'
              type='text'
            />
            <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='Course'
              type='text'
            />
            <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='Chapter'
              type='text'
            />
            <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='User'
              type='text'
            />

            <ThemeProvider theme={theme}>
              <Button
                onClick={editHandler}
                sx={{ marginTop: 3, boxShadow: 'none !important' }}
                variant='contained'
                color='neutral'
              >
                Update
              </Button>
            </ThemeProvider>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default VideoListModaledit;
